import { defineMessages } from 'react-intl';

export default defineMessages({
  sideNavLink_dashboard: {
    id: 'app.sidenav.link.title.dashboard',
    defaultMessage: 'Dashboard',
  },
  sideNavLink_products: {
    id: 'app.sidenav.link.title.products',
    defaultMessage: 'Your Company Products',
  },
  sideNavLink_approvals: {
    id: 'app.sidenav.link.title.approvals',
    defaultMessage: 'Approvals',
  },
  sideNavLink_accessories: {
    id: 'app.sidenav.link.title.accessories',
    defaultMessage: 'MOO Products',
  },
  sideNavLink_help: {
    id: 'app.sidenav.link.title.help',
    defaultMessage: 'Help',
  },
  sideNavLink_people: {
    id: 'app.sidenav.link.title.people',
    defaultMessage: 'People',
  },
  sideNavLink_orders: {
    id: 'app.sidenav.link.title.orders',
    defaultMessage: 'Order History',
  },
  sideNavLink_bulkEdit: {
    id: 'app.sidenav.link.title.bulkedit',
    defaultMessage: 'Bulk Edit',
  },
  sideNavLink_settings: {
    id: 'app.sidenav.link.title.settings',
    defaultMessage: 'Account Settings',
  },
});
